import { NavLink } from 'react-router-dom';
import logoName from '../../assets/imgs/logo-name.png';
import styles from './navFooter.module.css';

export const NavBar = () => {
  return (
    <div className={styles.navbar}>
      <NavLink to="">
        <img src={logoName} className={styles.logo} alt="logo" />
      </NavLink>
      <NavLink to="">
        <div className={styles.navbarLoginContainer}>{/* <p>Home</p> */}</div>
      </NavLink>
    </div>
  );
};
